/* @flow */

export default {
  EXTERNAL: {
    CMS: {
      UNIT_TESTING: "http://dl-testing/cms/v2",
      E2E_TESTING: "http://e2etesting:30000/cms/v2",
      LOCAL: "http://localhost:30010/cms/v2",
      DEV: "https://dlc-dlb-v2.dev.cf.oneweb.mercedes-benz.com/cms/v2",
      TEST: "https://test.api.oneweb.mercedes-benz.com/dlc-cms/v2",
      INT: "https://int.api.oneweb.mercedes-benz.com/dlc-cms/v2",
      PROD: "https://api.oneweb.mercedes-benz.com/dlc-cms/v2"
    },
    DMS: {
      UNIT_TESTING: "http://dl-testing/dms/v2",
      E2E_TESTING: "http://e2etesting:30000/dms/v2",
      LOCAL: "http://localhost:30020/dms/v2",
      DEV: "https://dlc-dlb-v2.dev.cf.oneweb.mercedes-benz.com/dms/v2",
      TEST: "https://test.api.oneweb.mercedes-benz.com/dlc-dms/v2",
      INT: "https://int.api.oneweb.mercedes-benz.com/dlc-dms/v2",
      PROD: "https://api.oneweb.mercedes-benz.com/dlc-dms/v2"
    }
  },
  INTERNAL: {
    DLB: {
      CMS: {
        UNIT_TESTING: "http://dl-testing/cms/v2",
        E2E_TESTING: "http://e2etesting:30000/cms/v2",
        LOCAL: "http://localhost:30010/cms/v2",
        DEV: "https://dlc-dlb-v2.dev.cf.oneweb.mercedes-benz.com/cms/v2",
        TEST: "https://dlc-dlb-v2.test.cf.oneweb.mercedes-benz.com/cms/v2",
        INT: "https://dlc-dlb-v2.int.cf.oneweb.mercedes-benz.com/cms/v2",
        PROD: "https://dlc-dlb-v2.prod.cf.oneweb.mercedes-benz.com/cms/v2"
      },
      DMS: {
        UNIT_TESTING: "http://dl-testing/dms/v2",
        E2E_TESTING: "http://e2etesting:30000/dms/v2",
        LOCAL: "http://localhost:30020/dms/v2",
        DEV: "https://dlc-dlb-v2.dev.cf.oneweb.mercedes-benz.com/dms/v2",
        TEST: "https://dlc-dlb-v2.test.cf.oneweb.mercedes-benz.com/dms/v2",
        INT: "https://dlc-dlb-v2.int.cf.oneweb.mercedes-benz.com/dms/v2",
        PROD: "https://dlc-dlb-v2.prod.cf.oneweb.mercedes-benz.com/dms/v2"
      }
    },
    SPA: {
      CMS: {
        UNIT_TESTING: "http://dl-testing/cms/v2",
        E2E_TESTING: "http://e2etesting:30000/cms/v2",
        LOCAL: "http://localhost:30010/cms/v2",
        DEV: "https://dlc-spa-v2.dev.cf.oneweb.mercedes-benz.com/cms/v2",
        TEST: "https://dlc-spa-v2.test.cf.oneweb.mercedes-benz.com/cms/v2",
        INT: "https://dlc-spa-v2.int.cf.oneweb.mercedes-benz.com/cms/v2",
        PROD: "https://dlc-spa-v2.prod.cf.oneweb.mercedes-benz.com/cms/v2"
      },
      DMS: {
        UNIT_TESTING: "http://dl-testing/dms/v2",
        E2E_TESTING: "http://e2etesting:30000/dms/v2",
        LOCAL: "http://localhost:30020/dms/v2",
        DEV: "https://dlc-spa-v2.dev.cf.oneweb.mercedes-benz.com/dms/v2",
        TEST: "https://dlc-spa-v2.test.cf.oneweb.mercedes-benz.com/dms/v2",
        INT: "https://dlc-spa-v2.int.cf.oneweb.mercedes-benz.com/dms/v2",
        PROD: "https://dlc-spa-v2.prod.cf.oneweb.mercedes-benz.com/dms/v2"
      }
    },
    DSW: {
      CMS: {
        UNIT_TESTING: "http://dl-testing/cms/v2",
        E2E_TESTING: "http://e2etesting:30000/cms/v2",
        LOCAL: "http://localhost:30010/cms/v2",
        DEV: "https://dlc-dsw-v2.dev.cf.oneweb.mercedes-benz.com/cms/v2",
        TEST: "https://dlc-dsw-v2.test.cf.oneweb.mercedes-benz.com/cms/v2",
        INT: "https://dlc-dsw-v2.int.cf.oneweb.mercedes-benz.com/cms/v2",
        PROD: "https://dlc-dsw-v2.prod.cf.oneweb.mercedes-benz.com/cms/v2"
      },
      DMS: {
        UNIT_TESTING: "http://dl-testing/dms/v2",
        E2E_TESTING: "http://e2etesting:30000/dms/v2",
        LOCAL: "http://localhost:30020/dms/v2",
        DEV: "https://dlc-dsw-v2.dev.cf.oneweb.mercedes-benz.com/dms/v2",
        TEST: "https://dlc-dsw-v2.test.cf.oneweb.mercedes-benz.com/dms/v2",
        INT: "https://dlc-dsw-v2.int.cf.oneweb.mercedes-benz.com/dms/v2",
        PROD: "https://dlc-dsw-v2.prod.cf.oneweb.mercedes-benz.com/dms/v2"
      }
    },
    DDW: {
      CMS: {
        UNIT_TESTING: "http://dl-testing/cms/v2",
        E2E_TESTING: "http://e2etesting:30000/cms/v2",
        LOCAL: "http://localhost:30010/cms/v2",
        DEV: "https://dlc-ddw-v2.dev.cf.oneweb.mercedes-benz.com/cms/v2",
        TEST: "https://dlc-ddw-v2.test.cf.oneweb.mercedes-benz.com/cms/v2",
        INT: "https://dlc-ddw-v2.int.cf.oneweb.mercedes-benz.com/cms/v2",
        PROD: "https://dlc-ddw-v2.prod.cf.oneweb.mercedes-benz.com/cms/v2"
      },
      DMS: {
        UNIT_TESTING: "http://dl-testing/dms/v2",
        E2E_TESTING: "http://e2etesting:30000/dms/v2",
        LOCAL: "http://localhost:30020/dms/v2",
        DEV: "https://dlc-ddw-v2.dev.cf.oneweb.mercedes-benz.com/dms/v2",
        TEST: "https://dlc-ddw-v2.test.cf.oneweb.mercedes-benz.com/dms/v2",
        INT: "https://dlc-ddw-v2.int.cf.oneweb.mercedes-benz.com/dms/v2",
        PROD: "https://dlc-ddw-v2.prod.cf.oneweb.mercedes-benz.com/dms/v2"
      }
    }
  }
};

export const Endpoint = {
  CMS: "CMS",
  DMS: "DMS"
};
